import type {IBalance} from "$lib/interfaces/IBalance";


export function sortCryptoCurrencies(cryptos: IBalance[]): IBalance[] {
    return [...cryptos].sort((a, b) => {
        if (a.name === 'USDT') return -1;
        if (b.name === 'USDT') return 1;

        // Then sort alphabetically
        return a.name.localeCompare(b.name);
    });
}